import { AuthorizationActionTypes } from './types';
import { setUserAuthData, setUserLoginStatus } from '../../helpers/authorization';
import { notifySuccess } from '../../helpers/notifications';

export const actions = {
    async [AuthorizationActionTypes.Login](context, { phone, password }) {
        return new Promise((resolve, reject) => {
            this.$api.login.post({
                body: { phone, password },
            }).then(response => {
                if (response?.data) {
                    setUserAuthData({ data: response.data.data })
                    setUserLoginStatus()
                    resolve(response)
                }
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    async [AuthorizationActionTypes.Precheck](context, { params } = {}) {
        return new Promise((resolve, reject) => {
            this.$api.precheck.get({
                params: { ...params },
            }).then(response => {
                // if (response?.data) {
                //     notifySuccess({ title: response.data.message })
                // }
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    async [AuthorizationActionTypes.Logout]() {
        try {
            const response = await this.$api.logout.post()
            if (response && response.data && response.data.message) {
                notifySuccess({ title: response.data.message })
            }
            return response
        } catch (error) {
            return null
        }
    },
}